import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { getCities } from '../../actions/userActions/cityAction'
import { getPracticeLocations } from '../../actions/userActions/practiceLocationAction';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DynamicTable from '../reuse_components/DynamicTable'
import CustomPagination from '../subComponents/pagination/CustomPagination'
import SearchInput from '../subComponents/search/SearchInput'
import BodySmallMedium from '../designSystem/BodySmallMedium'
import Heading6Regular from '../designSystem/Heading6Regular'
import CustomButton from '../subComponents/buttons/CustomButton'
import { Download } from 'lucide-react';
import { IconButton } from "@mui/material";
import { downloadPracticeLocation } from "../../actions/userActions/practiceLocationAction";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import AddPracticeLocations from './AddPracticeLocations'
import CustomCitySelect from '../subComponents/select/CustomCitySearchselect';
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector';
import GenericFilter, { FilterBar } from "../subComponents/Filter/GenericFilters";
import CustomFilterSelect from "../designSystem/CustomFilterSelect";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from '../../locales/translate';


function PracticeLocations() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [selectedCity, setSelectedCity] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [PracticeLocationData, setPracticeLocationData] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const allCities = useSelector((state) => state.cities_reducer.cities)
  const [citiesLoaded, setCitiesLoaded] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const [page, setPage] = useState(1)
  const [selected, setSelected] = useState({
    textSearch: '',
    city: 0,
  })
  const [filters, setFilters] = useState({
    textSearch: '',
    city: 0,
  })
  const [cityFilters, setCityFilters] = useState({
    textSearch: '',
    countryId: '1',
  })

  const body = {
    filter: filters,
    pageNumber: currentPage,
    itemsPerPage: itemsPerPage,
  }
  const cityBody = {
    filter: cityFilters,
    pageNumber: -1,
    pageSize: 0,
  }
  useEffect(() => {
    dispatch(getCities(cityBody))
      .then(() => {
        setCitiesLoaded(true);
        dispatch(getPracticeLocations(body))
      })
  }, [page, filters])

  const practiceLocations = useSelector(
    (state) => state.practiceLocations_reducer.practiceLocations
  )
  const isCitiesLoading = useSelector((state) => state.cities_reducer.isCitiesLoading);
  const isPracticeLocationLoading = useSelector(
    (state) => state.practiceLocations_reducer.isPracticeLocationLoading
  );

  const isLoading = isPracticeLocationLoading || isCitiesLoading;

  const citydata = allCities?.result
const cityOptions = [
  { id: 0, name: 'All' },
  ...(citydata?.map(city => ({
    id: city.id,
    name: city.name
  })) || [])
];

const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

const handleClearAllFilters = () => {
  if (selectedCity === '' && selected.textSearch === '') return;

  setSelectedCity('');
  setSelected({ textSearch: '' });
  setFilters({
    textSearch: '',
    city: 0
  });
  setCurrentPage(1);
};


  useEffect(() => {
    const practiceLocationsData = practiceLocations?.result || [];

    setPracticeLocationData(practiceLocationsData);
  }, [practiceLocations]);
  const totalPages = practiceLocations?.totalPages || 0;
  const totalItems = practiceLocations?.totalCount || 0;

  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const getPaginationNo = (pageNum) => {
    const object = []
    if (practiceLocations !== isPracticeLocationLoading && practiceLocations.length !== 0) {
      for (let i = 0; i < practiceLocations[0].page.totalPages; i++) {
        object.push(
          <button
            className={pageNum == i + 1 ? 'active' : ''}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>,
        )
      }
    }
    return object
  }

  const handleSearch = (e) => {
    setSelected({ ...selected, ['textSearch']: e.target.value })
    if (e.target.value.length >= 1) {
      setTimeout(() => {
        setFilters({ ...filters, ['textSearch']: e.target.value })
      }, 500)
    }
    if (e.target.value == '') {
      setFilters({ ...filters, ['textSearch']: e.target.value })
    }
  }

  useEffect(() => {
    dispatch(getPracticeLocations(body));
  }, [filters, currentPage]);
  const handleCityChange = (event) => {
  const value = event.target.value;
  setSelectedCity(value);
  setFilters({
    ...filters,
    city: value 
  });
  setCurrentPage(1);
};
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("locationType")}`, accessor: "typeName" },
    { label: `${t("address")}`, accessor: "address" },
  ];
  const handleEditPracticeLocation = (row) => {
    setEditData(row);
    setShowModal(true);
  };
  const actions = [
    {
      label: 'Edit Practice location',
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: 'CanUpdatePracticeLocation',
      handler: handleEditPracticeLocation,
    },
  ];
  const handleAddPracticeLocationClick = () => {
    setEditData(null);
    setShowModal(true);
  };
  const handleItemsPerPageChange = (value) => {
    setItemsPerPage(value);
    setCurrentPage(1);
    const updatedBody = {
      filter: filters,
      pageNumber: 1, // Reset to page 1
      itemsPerPage: value,
    };
    dispatch(getPracticeLocations(updatedBody));
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
  setShowModal(false);
  await dispatch(getPracticeLocations(body));
};
 const handlePracticeLocationDownload = () => {
  const body = {
    filter: filters,
    pageNumber: currentPage,
    pageSize: itemsPerPage, 
  };
  dispatch(downloadPracticeLocation(body));
};
  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading && !showModal} />
        <div className="main-container">
          <div className="content-wrapper p-0">
             <div className="" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 16px' }}>
              <SearchInput
                placeholder="Search"
                onChange={handleSearch}
                value={selected.textSearch}
              />

              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ minWidth: '80px', marginRight: '10px' }}>
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
                <div style={{ paddingRight: '12px' }}>
                    <IconButton onClick={handlePracticeLocationDownload}>
                      <Download />
                    </IconButton>
                    </div>
                <div style={{marginRight: "12px"}}>
                 <GenericFilter
                  showFilters={showFilters}
                  toggleFilters={toggleFilters}
                  />
                  </div>
                {permissions && permissions.includes("CanAddPracticeLocation") && (
                  <CustomButton text={t("addNew")} onClick={handleAddPracticeLocationClick} />
                )}
              </div>
            </div>

                <FilterBar
                showFilters={showFilters}
                onClearAll={handleClearAllFilters}
                >
                <CustomFilterSelect
                label={t("city")}
                value={selectedCity}
                onChange={handleCityChange}
                options={cityOptions} // Your cities array
                disabled={!citiesLoaded}
                width="220px"
                searchable={true}
                searchPlaceholder="Search cities..."
                noDataText="No cities available"
                />
                </FilterBar>
          </div>
          <DynamicTable
            data={PracticeLocationData}
            columns={columns}
            permissions={permissions}
            actions={actions}
            thIcon={thIcon}
            showPagination={totalItems > 0}
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>

        {showModal && (
          <AddPracticeLocations
            onClose={handleCloseModal}
            editData={editData}
            onSave={handleSaveData}
          />
        )}
      </div>

    </>
  )
}

export default PracticeLocations
